import React, { useEffect, useState } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { api } from '../services/api';
import BrandCard from './BrandCard';

const BrandsGrid = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const [hoveredBrand, setHoveredBrand] = useState(null);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.getBrands()
      .then((res) => mounted && setBrands(res?.data || []))
      .catch(() => mounted && setBrands([]));
    return () => { mounted = false; };
  }, []);

  return (
    <section ref={ref} className={`py-16 bg-white fade-in-up ${isVisible ? 'visible' : ''}`}>
      <div className="pp-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            برندهای همکار
          </h2>
          <p className="text-gray-600">بیش از 50 برند معتبر صنعتی</p>
        </div>

        {brands.length === 0 ? (
          <div className="text-center text-sm text-gray-500">هنوز برندی از داشبورد ثبت نشده است.</div>
        ) : (
        <div className="flex flex-wrap justify-center gap-4">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="relative group basis-[calc(20%-0.8rem)] md:basis-[calc(10%-0.9rem)] min-w-[76px] max-w-[104px]"
              onMouseEnter={() => setHoveredBrand(brand.id)}
              onMouseLeave={() => setHoveredBrand(null)}
            >
              <BrandCard brand={brand} />
              
              {/* Tooltip on Hover */}
              {hoveredBrand === brand.id && (
                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-xs px-3 py-2 rounded-lg whitespace-nowrap z-10 shadow-lg">
                  {brand.name}
                  <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
                </div>
              )}
            </div>
          ))}
        </div>
        )}
      </div>
    </section>
  );
};

export default BrandsGrid;
